import SEO from "../components/common/SEO";
import Hero from "../components/home/Hero";
import Marquee from "../components/home/Marquee";
import TrustSection from "../components/home/TrustSection";
import ServicesSection from "../components/home/ServicesSection";
import DataFlowStory from "../components/home/DataFlowStory";
import IndustriesGrid from "../components/home/IndustriesGrid";
import OrganizationsSection from "../components/home/OrganizationsSection";
import ProcessTimeline from "../components/home/ProcessTimeline";
import WhyAmvi from "../components/home/WhyAmvi";
import CTASection from "../components/common/CTASection";

export default function Home() {
  return (
    <>
      <SEO
        title="AI, Data, Cloud & Talent Solutions"
        description="AMVI Technologies is a U.S. technology consulting and talent solutions company delivering AI, data engineering, cloud, software and specialized staffing."
        path="/"
      />
      <Hero />
      <Marquee />
      <TrustSection />
      <ServicesSection />
      <DataFlowStory />
      <IndustriesGrid />
      <OrganizationsSection />
      <ProcessTimeline />
      <WhyAmvi />
      <CTASection
        title="AMVI can provide technology solutions and highly skilled talent."
        subtitle="Whether you're modernizing with AI and cloud or building a specialized engineering team, let's talk."
      />
    </>
  );
}
